import css from '@emotion/css';
import styled from '@emotion/styled';

export const SavedSuccessBlock = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};

  ${({ theme }) => theme.media.showAt({ to: 2 })`
    padding-top: ${theme.spacing(2)};
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing(3)};
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const FiltersWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
    padding: ${theme.spacing(2)};
    border: 1px solid ${theme.colors.neutrals.grey8};
    border-radius: ${theme.borderRadius.small};
  `}
`;

export const FrequencyBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const FrequencyList = styled.div`
  display: flex;
  flex-direction: column;
`;
